import React, { Fragment } from 'react';

// Components

import BlockWrapper from './BlockWrapper';

// Utils

import { normalizeStringToBooleanValue } from '@utils/normalize/normalizeStringToBooleanValue';
import { processJsonTools } from '@utils/tools/processJsonTools';


const CurrentJsonExtractor = props => {

    const {
        id,
        name,
        buttons,
        data,
        refToJsonTextArea,
        handleToggle
    } = props;

    const handleJsonCopying = e => {

        const {
            name: extractionType,
            dataset: {
                skip
            }
        } = e.currentTarget;

        ((target => {
            const application = processJsonTools.convertTaxHousehold(
                processJsonTools.processDataStringifyingUiProperties(target.value),
                extractionType,
                normalizeStringToBooleanValue(skip)
            );
            target.value = JSON.stringify(
                skip
                    ? application
                    : { singleStreamlinedApplication: application }
            );
            return target;
        })(refToJsonTextArea.current)).select();
        document.execCommand('copy');
        handleToggle({ target: { name } });
    };

    const getButtons = () => {
        return buttons.map(btn => {

            const [ name, extractionType, skipUiPropertiesConversion ] = btn;

            return (
                <Fragment key={name}>
                    <button
                        name={extractionType}
                        data-skip={skipUiPropertiesConversion}
                        onClick={handleJsonCopying}
                        style={{ borderRadius: '3px' }}
                    >
                        <span style={{ display: 'block', padding: '3px' }}>{ name }</span>
                    </button>
                    <br/>
                </Fragment>
            );
        });
    };

    return (
        <BlockWrapper id={id}>

            <textarea
                style={{ width: '450px', height: '450px' }}
                onChange={() => {}}
                ref={refToJsonTextArea}
                value={JSON.stringify(data, undefined, 4)}
                name = "json"
            />
            {
                getButtons()
            }
        </BlockWrapper>
    );
};

export default CurrentJsonExtractor;